import { useLocation, useParams, useSearchParams, useNavigate } from "react-router-dom";
import RSSB_LOGO from "../assets/RSSB_LOGO.jpeg";
import { useEffect, useState } from "react";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import Swal from "sweetalert2";
import '../styles/noPrint.css'
import moment from "moment";

const PreviewGatePass = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const personId = searchParams.get('personId')

  const navigate = useNavigate()

  let id = searchParams.get('gatepassId') ? searchParams.get('gatepassId') : location.state?.id
  const [data, setData] = useState([])
  const [rowData, setRowData] = useState([])
  const token = localStorage.getItem('token')
  const [profileDetails, setProfileDetails] = useState(null);
  const centerCode = localStorage.getItem('code')
  const email = localStorage.getItem('email');
  const name = localStorage.getItem('name');
  const badgeId = localStorage.getItem('badgeId');
  const pin = localStorage.getItem('pin');
  const [signatureUrl, setSignatureUrl] = useState(null);
  const [showSignature, setShowSignature] = useState(false);

  useEffect(() => {
    if (!token) {
      // Redirect to login page with additional data
      navigate(
        `/?redirect=${encodeURIComponent(window.location.pathname + window.location.search)}&type=gatePass`
      );
      return;
    }
    const fetchCenterInfo = async () => {
      try {
        const response = await apiClient.get(`${SERVER_BASE}/centerInfoForDC`, {
          params: { code: centerCode },
          headers: { 'Authorization': `Bearer ${token}` },
        });

        const center = response.data[0];
        setData(center);

        if (center?.signature?.data) {
          const byteArray = new Uint8Array(center?.signature?.data);
          let binary = '';
          byteArray.forEach(byte => {
            binary += String.fromCharCode(byte);
          });
          const base64String = window.btoa(binary);
          setSignatureUrl(`data:image/jpeg;base64,${base64String}`);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchCenterInfo();
  }, []);



  const fetchProfileDetails = async () => {
    try {
      const response = await apiClient.get(`${SERVER_BASE}/getProfile`, { params: { email } });
      setProfileDetails(response.data?.[0] || null); // Assume the first row contains the profile data
    } catch (err) {
      console.error('Error fetching profile details:', err);
      setProfileDetails(null);

    }
  };


  const handleApprove = () => {
    // SweetAlert2 for PIN input
    Swal.fire({
      title: 'Enter your PIN',
      input: 'password',
      inputPlaceholder: 'Enter your PIN',
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      confirmButtonText: 'Submit',
      inputValidator: (value) => {
        if (!value) {
          return 'Please enter your PIN.';
        }
        if (value != pin) {
          return 'Invalid PIN. Please try again.';
        }
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // Proceed with the approval if PIN matches
        const approvedBy = name;
        const approvedByBadge = badgeId;

        // Send the approval request to the backend
        apiClient.post(`${SERVER_BASE}/approveGatePass/${id}`, {
          approvedBy,
          approvedByBadge
        })
          .then(response => {
            Swal.fire({
              icon: 'success',
              title: 'Gate Pass Approved!',
              text: 'The gate pass has been approved successfully.',
              confirmButtonText: 'OK',
            }).then(() => {
              window.location.reload();
            });
          })
          .catch(err => {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: `Failed to approve the gate pass: ${err.response?.data?.message || err.message}`,
              confirmButtonText: 'OK',
            });
          });
      }
      // fetchDraftData();
    });
  };
  useEffect(() => {
    const fetchRowData = async () => {
      try {

        const response = await apiClient.get(`${SERVER_BASE}/viewGatePass`, {
          params: { id: id },
          headers: {
            'Authorization': `Bearer ${token}`, // Add the JWT token in the header
          },
        });
        setRowData(response.data);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchRowData();
    fetchProfileDetails();
  }, []);

  if (!rowData) {
    return <p>No data available. Please go back to the list.</p>;
  }

  const organization = {
    name: data?.centerName,
    addressLine1: data?.addressLine1,
    addressLine2: data?.addressLine2,
    addressLine3: data?.addressLine3,
    mobile1: data?.mobile1,
    mobile2: data?.mobile2,
    gstin: data?.gstin,
    contactPerson1: data?.contactPerson1,
    contactPerson2: data?.contactPerson2,
    position1: data?.position1,
    position2: data?.position2
  };

  const itemDetails = rowData?.itemDetails || [];
  const remarks = rowData?.remarks || '';
  const footer = 'H.O. Dera Baba Jaimal Singh, Beas, Distt. Amritsar, Punjab 143 204, India';

  return (
    <div style={{ margin: 'auto', padding: '20px', fontFamily: 'Arial, sans-serif', maxWidth: '800px', fontSize: '10px' }}>
      {/* Header Section */}
      <div className="d-flex justify-content-between mb-3">
        {/* Back Button - Always visible */}
        <button className="btn btn-secondary no-print" onClick={() => window.history.back()}>
          Back
        </button>

        {/* Approve Button - Conditional rendering */}
        {profileDetails && (String(profileDetails.id) == String(personId) || String(profileDetails.id) == rowData[0]?.authorizedPersonId) && (rowData[0]?.status != 'Approved') && (
          <>
            <button className="btn btn-success no-print" onClick={handleApprove}>
              Approve
            </button>
          </>
        )}
        {/* {(rowData[0]?.status == 'Approved') &&
        <button
          className="btn btn-primary no-print"
          onClick={() => {
            if (!signatureUrl) {
              Swal.fire(
                'No signature found',
                'Please ensure signature is uploaded in center info.',
                'warning'
              );
              return;
            }
            setShowSignature(prev => !prev); // toggle visibility
          }}
        >
          {showSignature ? 'Clear Signature' : 'Imprint Signature'}
        </button>} */}
      </div>
      <div className="d-flex align-items-start border-bottom pb-2">
        <img src={RSSB_LOGO} alt="Logo" className="me-3" style={{ height: '65px' }} />
        <div className="text-start">
          <h6 className="mb-0">{organization?.name}</h6>
          <p className="mb-0">{organization?.addressLine1}</p>
          <p className="mb-0">{organization?.addressLine2}</p>
          <p className="mb-0">{organization?.addressLine3}</p>
        </div>
      </div>
      <div className="text-center mt-1" style={{ fontSize: '14px', lineHeight: '1.6' }}>
        <h3 className="fw-bold" style={{ fontSize: '17px' }}>
          गेट पास
        </h3>
      </div>

      <div className='mt-2 d-flex justify-content-between' style={{ fontSize: '16px' }}>
        <p>गेट पास संख्या: {rowData[0]?.gatePassCode}</p>
        <p>दिनांक: {rowData[0]?.gatePassDate ? new Intl.DateTimeFormat('en-US', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(rowData[0].gatePassDate)) : ''}</p>
      </div>
      <div className="" style={{ fontSize: '14px' }}>
        <div className="d-flex justify-content-between">
          <p className="mb-2">
            <span className="fw-bold">वाहन संख्या : </span>
            {rowData[0]?.vehicleNumber}
          </p>
          <p className="mb-2">
            <span className="fw-bold">वाहन चालक का नाम : </span>
            {rowData[0]?.driverName}
          </p>
          <p className="mb-2">
            <span className="fw-bold">मोबाइल नंबर : </span>
            {rowData[0]?.mobileNum}
          </p>
        </div>
        {rowData[0]?.ledger ? (
          <div className="d-flex justify-content-between mb-2">
            <p className="mb-0">
              <span className="fw-bold">कहा से आया / आयेगा : </span>
              {rowData[0].ledger}
            </p>
          </div>
        ) : null}
        {rowData[0]?.gatePassCause == 'वाहन का गेट पास, जिसके सामान का डिलीवरी चालान बनाने की आवश्यकता नहीं है |' ? (
          <div className="d-flex justify-content-between mb-1">
            <p className="mb-0">
              <span className="fw-bold">उद्देश्य : </span>
              {rowData[0].purpose}
            </p>
          </div>
        ) : null}
      </div>
      <div className='mt-2 d-flex justify-content-between' style={{ fontSize: '15px' }}>
        <p className="mb-0">
          <span className="fw-bold">अन्य कोई विवरण: </span>
          <span className="">{rowData[0]?.remarks}</span>
        </p>
      </div>

      {rowData[0]?.gatePassCause == 'वाहन का गेट पास, जिसका पूरा सामान उतारा जा चुका है |' ?
        (<div className="border border-dark p-3 mt-1">
          <ul className="list-unstyled m-0" style={{ fontSize: '12px', lineHeight: '1.8' }}>
            <li>
              <span className="me-2">•</span>
              {rowData[0]?.freightOn == 0 ? (
                <>
                  सेवा वाहन <span className="text-success fw-bold">✔</span>
                </>
              ) : rowData[0]?.freightOn == 1 ? (
                <>
                  भाड़े पर लिया गया वाहन, Rs. {rowData[0]?.totalFreight}/-{' '}
                  <span className="text-success fw-bold">✔</span>
                </>
              ) : (
                'भाड़े की जानकारी उपलब्ध नहीं है'
              )}
            </li>
            <li>
              <span className="me-2">•</span>
              {rowData[0]?.documents == 'मूल दस्तावेज प्राप्त किए' ? (
                <>
                  मूल दस्तावेज प्राप्त किए <span className="text-success fw-bold">✔</span>
                </>
              ) : rowData[0]?.documents == 'मूल दस्तावेजों की प्रति प्राप्त की' ? (
                <>
                  मूल दस्तावेजों की प्रति प्राप्त की <span className="text-success fw-bold">✔</span>
                </>
              ) : (
                'दस्तावेज की जानकारी उपलब्ध नहीं हैं'
              )}
            </li>
            <li>
              <span className="me-2">•</span>
              {rowData[0]?.itemsChecked == 1 ? (
                <>
                  सामान तथा गुणवत्ता की जांच की गई <span className="text-success fw-bold">✔</span>
                </>
              ) : rowData[0]?.itemsChecked == 0 ? (
                <>
                  सामान तथा गुणवत्ता की जांच की गई तथा एरिया ऑफिस को सूचित किया गया <span className="text-success fw-bold">✔</span>
                </>
              ) : (
                'सामान की जांच की जानकारी उपलब्ध नहीं है'
              )}
            </li>
            <li>
              <span className="me-2">•</span>
              {rowData[0]?.itemCount == 1 ? (
                <>
                  सामान की मात्रा सही है <span className="text-success fw-bold">✔</span>
                </>
              ) : rowData[0]?.itemCount == 0 ? (
                <>
                  सामान की मात्र सही नहीं है, एरिया ऑफिस को सुजीत किया जा चुका हैं <span className="text-success fw-bold">✔</span>
                </>
              ) : (
                'सामान के मात्र की जांच की जानकारी उपलब्ध नहीं है'
              )}
            </li>
          </ul>
        </div>) : (
          (() => {
            const allowedPurposes = [
              'डीजल /  पेट्रोल  भराई  के  लिए',
              'कांटा पर्ची करवाने  हेतु',
              'कचरे से लदा वाहन',
              'अवशिष्ट पेड़ या घास कचरे से लदा वाहन',
              'वाहन की मरम्मत के लिए'
            ];

            const purpose = rowData[0]?.purpose;

            // ✅ Case 1: allowedPurposes list
            if (allowedPurposes.includes(purpose)) {
              return (
                <div style={{ fontSize: '15px', marginTop: '10px', textAlign: 'center', lineHeight: '1.6' }}>
                  <div style={{ textAlign: 'justify' }} className="">
                  यह वाहन केवल उक्त वर्णित उद्देश्य के लिए ही बाहर की ओर जा रहा है,
                  उक्त के संदर्भ में सक्षम अधिकारी की अनुमति ले ली गई है और वाहन अनुमेय सीमा में चल रहा है।
                  </div>
                </div>
              );
            }

            // ✅ Case 2: Inward Memo
            if (purpose == 'वापसी योग्य सामान जिसका इन्वार्ड मेमो बनाया गया था') {
              return (
                <div style={{ fontSize: '15px', marginTop: '10px', textAlign: 'center', lineHeight: '1.6' }}>
                  <div style={{ textAlign: 'justify' }} className="border border-dark p-3 mt-1 fw-bold">
                    मैं स्वीकार करता/करती हूँ कि वाहन केवल ऊपर वर्णित उद्देश्य के लिए ही बाहर की ओर जा रहा है और
                    ले जाया जा रहा सामान का विवरण इन्वार्ड मेमो # {rowData[0]?.inwardMemoNo}, दिनांक {rowData[0]?.inwardMemoDate} में बताया गया है।
                  </div>
                </div>
              );
            }

            // ✅ Case 3: Consumable distribution
            if (purpose == 'संगत या सेवादारों के उपभोग के लिए उपभोग्य सामग्रियों का वितरण') {
              return (
                <div style={{ fontSize: '15px', marginTop: '10px', textAlign: 'center', lineHeight: '1.6' }}>
                  <div style={{ textAlign: 'justify' }} className="border border-dark p-3 mt-1 fw-bold">
                    नीचे उल्लिखित इन्वेंट्री को स्टोरा की खपत के रूप में माना जाएगा
                  </div>
                </div>
              );
            }

            // ✅ Case 4: Sangat/Sevadars transport with/without goods
            if (purpose == 'संगत और सेवादारों को लाने व ले जाने के लिए') {
              if (rowData[0]?.isCarryingGoods != 1) {
                // Not carrying goods
                return (
                  <div style={{ fontSize: '15px', marginTop: '10px', textAlign: 'center', lineHeight: '1.6' }}>
                    <div style={{ textAlign: 'justify' }} className="border border-dark p-3 mt-1 fw-bold">
                      मैं स्वीकार करता/करती हूँ कि वाहन केवल ऊपर वर्णित उद्देश्य के लिए ही बाहर की ओर जा रहा है और
                      उसमें किसी भी सत्संग घर का सामान नहीं है, सक्षम अधिकारी की अनुमति ले ली गई है और वाहन अनुमेय सीमा में चल रहा है।
                    </div>
                  </div>
                );
              } else {
                // Carrying goods
                return (
                  <div style={{ fontSize: '15px', marginTop: '10px', textAlign: 'center', lineHeight: '1.6' }}>
                    <div style={{ textAlign: 'justify' }} className="border border-dark p-3 mt-1 fw-bold">
                      मैं स्वीकार करता/करती हूँ कि वाहन केवल ऊपर वर्णित उद्देश्य के लिए ही बाहर की ओर जा रहा है और
                      उसमें सत्संग घर का सामान ले जाया जा रहा है जिसका विवरण चालान संख्या {rowData[0]?.challanNo} दिनांक {rowData[0]?.challanDate} में किया गया है,
                      सक्षम अधिकारी की अनुमति ले ली गई है
                    </div>
                  </div>
                );
              }
            }

            return null; // default if nothing matches
          })()
        )}


      <div className="mt-2" style={{ fontSize: '14px' }}>
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <p className="mb-1">
              <span className="fw-bold">Prepared By : </span> {rowData[0]?.createdBy} ({rowData[0]?.createdByBadge}), {rowData[0]?.createdAt
                  ? new Intl.DateTimeFormat('en-GB', {
                    hour: '2-digit',
                    minute: '2-digit',
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric',
                  }).format(new Date(rowData[0]?.createdAt))
                  : ''} 
            </p>
            {rowData[0]?.approvedBy && <>
              <p className="mb-1">
                <span className="fw-bold">Verified By: </span> {rowData[0]?.approvedBy} ({rowData[0]?.approvedByBadge}),   {rowData[0]?.approvedAt
                  ? new Intl.DateTimeFormat('en-GB', {
                    hour: '2-digit',
                    minute: '2-digit',
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric',
                  }).format(new Date(rowData[0]?.approvedAt))
                  : ''}
              </p>
            </>}
          </div>
          <div className="text-end fw-bold mb-0">

          </div>
        </div>
        <div className="text-end" style={{ position: 'relative' }}>
          {showSignature && signatureUrl && (
            <img
              src={signatureUrl}
              alt="Signature"
              style={{
                maxWidth: '180px',
                height: '120px',
                pointerEvents: 'none',
                transform: 'rotate(-2deg)', // slight tilt
                opacity: 0.9, // ink blend
                display: 'inline-block',
              }}
            />
          )}
        </div>


      </div>
      {rowData[0]?.approvedBy ? (
        <div className="mt-4 text-center" style={{ fontSize: '14px' }}>
          {/* उप्त गेट पास {rowData[0]?.approvedBy} ({rowData[0]?.approvedByBadge}){' '}
          {rowData[0]?.approvedAt
            ? moment(rowData[0]?.approvedAt).format('DD-MMM-YYYY, hh:mm A')
            : ''}{' '}
          द्वारा अनुमोदित किया गया है।  */}
          यह गेट पास इलेक्ट्रॉनिक रूप में स्वीकार्य है, इसकी भौतिक प्रति की आवश्यकता नहीं है।
        </div>
      ) : null}

      <footer className="footer" style={{
        textAlign: 'center',
        marginTop: '20px',
        fontSize: '12px',
        borderTop: '1px solid black',
        paddingTop: '10px',
        fontWeight: 'bolder'
      }}>
        {footer}
      </footer>

      {/* CSS for print media */}
      <style>
        {`
                @media print {
                  .footer {
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    page-break-before: always;
                  }
                }
              `}
      </style>
    </div>
  );
};

export default PreviewGatePass;
